import bgImage from '../images/bg.jpg';
import NoiseOverlay from './NoiseOverlay';

const ImageSection = () => {
  return (
    <NoiseOverlay>
      <div className="w-full border-t-8 border-black h-[300px] md:h-[700px] bg-cover"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }}
      />
    </NoiseOverlay>
  )
}

export default ImageSection
